import _ from "lodash";

import { localStorageDict, roles } from "../../../services/enums/index.js";
import { rootUrl } from "../../../services/routes.js";
import { writeStorage } from "../../../services/utils/index.js";

export default (callback, history, roleBack) => () => {
  if (_.isFunction(callback)) {
    callback();
  }
  history.push(rootUrl());

  if (_.isNil(roleBack)) {
    writeStorage(localStorageDict.ROLE, roles.CUSTOMER);
    writeStorage(localStorageDict.ROLE_BACK, roles.COACH);
  } else {
    writeStorage(localStorageDict.ROLE, roles.COACH);
    writeStorage(localStorageDict.ROLE_BACK, null);
  }
};
